import React, { useEffect, useState } from "react";
import { Picker, Item, ListBox, Text, ComboBox, Grid } from "@adobe/react-spectrum";
import { useAsyncList } from "@react-stately/data";
import { useDependency } from "../../../../../contexts/DependencyProvider";
import { ListCityRequest } from "../../../../../services/soap/translate/reqeusts/ListCityRequest";
import { ListZipRequest } from "../../../../../services/soap/translate/reqeusts/ListZipRequest";
import { ListUserRequest } from "../../../../../services/soap/access/requests/ListUserRequest";
import { useTranslation } from "react-i18next";


export interface Character {
    aclh: string,
    active: string,
    contactId: string,
    contactName: string,
    created: string,
    id: string,
    lastLogin: string,
    logged: string,
    name1: string
    name3: string
    numberOfSessions: string,
    userName: string
}

interface IUserDropDownProps{
  selectedUser:string;
  onChange:(data:Character)=>void;
  width?:number
  isRequired?:any
  errorMessage?:any
  validationState?:any
  isHidden?:boolean
}

const UserDropDown:React.FC<IUserDropDownProps> = ({
  selectedUser,
  onChange,
  width,
  isRequired,
  errorMessage,
  validationState,
  isHidden
})=> {
  const { store, accessService } = useDependency();
  const [selectedKey, setSelectedKey] = useState<string | null>(null);
  const { t } = useTranslation('contacts');
  const _t = (key: string) => t(`addNewCompany.${key}`, { ns: 'contacts' });

  useEffect(()=>{
     list.reload();
  },[])

  useEffect(() => {
        if (selectedUser) {
          setSelectedKey(selectedUser);
          list.reload();
        } else {
          setSelectedKey(null);
        }
      }, [selectedUser]);

  const list = useAsyncList<Character>({
  async load({ cursor, filterText }) {
    const offset = cursor ? Number(cursor) : 0;
    const limit = 50;
    try {
      const request = new ListUserRequest(store.Server, store.SessionId);
      const response = await accessService.listUser(request);

      const users = (response?.USERS || []).map((u: any) => u.USER); // flatten structure

      if (!Array.isArray(users)) {
        console.error("Invalid API response: Expected an array", response);
        return { items: [] };
      }

      return {
        items: users,
        cursor: users.length === limit ? String(offset + limit) : undefined,
      };
    } catch (error) {
      console.error("Error fetching users:", error);
      return { items: [] };
    }
  },
});

  const handleChange = (data:any)=>{
    setSelectedKey(data);
    const selectedUsr = list.items.find(x=>x.userName === data);
    if(selectedUsr){
      onChange(selectedUsr)
    }
  }

  return (
    <ComboBox
    label={_t("user")}
    aria-label={_t("user")}
    items={list.items}
    selectedKey={selectedKey}
    onInputChange={list.setFilterText}
    loadingState={list.loadingState}
    onLoadMore={list.loadMore}
    onSelectionChange={handleChange}
    width= {{base:"100%",L:"50%"}}
    isRequired={isRequired}
    errorMessage={errorMessage}
    validationState={validationState}
    isHidden={isHidden}
>
  {(item) => (
    <Item key={item.userName} textValue={item.contactName || item.name1}>
      {item.contactName || item.name1}
    </Item>
  )}
</ComboBox>
  );
};

export default UserDropDown;
